import React from "react";
import "aos/dist/aos.css";
import "./style.css";
import { FaGraduationCap, FaUniversity, FaCalendarAlt, FaMapMarkerAlt, FaAward } from "react-icons/fa";

const Education = () => {
  const educationData = [
    {
      id: 1,
      degree: "Master of Intelligent and Decision-making Systems",
      abbreviation: "MSID",
      level: "Bac+5 (Master's Degree)",
      field: "Intelligent Systems & Decision Making",
      institution: "Faculty of Sciences – Sidi Mohamed ben Abdellah University",
      location: "Fez, Morocco",
      period: "2021 - 2023",
      //   duration: "2 years",
      description: "Advanced studies in intelligent systems, artificial intelligence, decision-making algorithms, and data analysis. Focused on developing expertise in machine learning, deep learning, parallel computing, optimization techniques, distributed databases, big data technologies, and intelligent system design.",
      achievements: [
        "DL",
        "ML Algorithms",
        "Big Data Technologies",
        "Distributed Databases (BDD Réparties)",
        "Oracle Database Administration",
        "Design Patterns & Software Architecture",
        "Parallel Computing",
        "Advanced Decision-making Systems",
        "Data Analysis and Optimization"
      ],
      icon: <FaGraduationCap className="text-3xl" />,
      color: "bg-blue-100 dark:bg-blue-900/30 text-blue-800 dark:text-blue-300"
    },
    {
      id: 2,
      degree: "Bachelor of Science in Mathematics and Computer Science",
      abbreviation: "SMI",
      level: "Bac+3 (Bachelor's Degree)",
      field: "Mathematics & Computer Science",
      institution: "Faculty of Sciences - Moulay Ismail University",
      location: "Meknes, Morocco",
      period: "2016 - 2020",
      //   duration: "4 years",
      description: "Comprehensive foundation in mathematics, computer science fundamentals, algorithms, data structures, and software engineering. Built strong analytical and problem-solving skills through rigorous coursework and practical projects.",
      achievements: [
        "Mathematics & Algorithms",
        "Computer Science Fundamentals",
        "Data Structures & Algorithms",
        "Software Engineering Principles",
        "Database Management Systems",
        "Object-Oriented Programming"
      ],
      icon: <FaUniversity className="text-3xl" />,
      color: "bg-green-100 dark:bg-green-900/30 text-green-800 dark:text-green-300"
    }
  ];

  return (
    <section
      id="education"
      className="bg-white dark:bg-gray-600 pt-16 pb-20 transition-colors duration-300"
    // data-aos="fade-up"
    >
      <div className="container mx-auto px-4 ">
        <div className="experience-card bg-white dark:bg-gray-700 
          w-full md:w-[900px] lg:w-[1000px] mx-auto mt-10 pb-12 px-4 lg:px-10 
          border-2 border-primaryColor dark:border-primaryColorDark shadow-lg 
          dark:shadow-2xl transition-colors duration-300 rounded-lg">

          {/* Header Section */}
          <div className="text-center mb-12 pt-8">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-800 dark:text-primaryColorDark mb-4 transition-colors duration-300">
              <span className="border-b-4 border-primaryColor dark:border-primaryColorDark pb-2 transition-colors duration-300 inline-block">
                Education & Academic Background
              </span>
            </h1>
            <p className="text-gray-600 dark:text-gray-300 text-lg mt-4 transition-colors duration-300">
              My academic journey in Computer Science and Intelligent Systems
            </p>
          </div>

          {/* Education Timeline */}
          <div className="relative">
            {/* Timeline Line */}
            <div className="absolute left-8 md:left-12 top-0 bottom-0 w-1 bg-primaryColor dark:bg-primaryColorDark transition-colors duration-300"></div>

            {/* Education Items */}
            <div className="space-y-12">
              {educationData.map((education, index) => (
                <div
                  key={education.id}
                  // data-aos="fade-right"
                  // data-aos-delay={index * 200}
                  className="relative pl-20 md:pl-24"
                  style={{ backgroundColor: 'transparent' }}
                >
                  {/* Timeline Dot */}
                  <div className="absolute left-4 md:left-8 top-2 w-8 h-8 rounded-full bg-primaryColor dark:bg-primaryColorDark border-4 border-white dark:border-gray-700 shadow-lg flex items-center justify-center transition-colors duration-300 z-10">
                    <div className="text-white text-sm">
                      {education.icon}
                    </div>
                  </div>

                  {/* Education Card */}
                  <div className="bg-white dark:bg-gray-600 rounded-xl p-6 md:p-8 shadow-md hover:shadow-xl transition-all duration-300 border border-gray-200 dark:border-gray-600 hover:border-primaryColor dark:hover:border-primaryColorDark">
                    {/* Degree Badge */}
                    <div className="flex items-start justify-between flex-wrap gap-4 mb-4">
                      <div className="flex items-center gap-3">
                        <div className={`${education.color} p-3 rounded-lg`}>
                          {education.icon}
                        </div>
                        <div>
                          <h2 className="text-xl md:text-2xl font-bold text-gray-800 dark:text-white mb-1 transition-colors duration-300">
                            {education.degree}
                          </h2>
                          <div className="flex items-center gap-2 flex-wrap">
                            <span className="px-3 py-1 bg-primaryColor/10 dark:bg-primaryColorDark/20 text-primaryColor dark:text-primaryColorDark text-sm font-semibold rounded-full">
                              {education.abbreviation}
                            </span>
                            <span className="px-3 py-1 bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-300 text-sm font-medium rounded-full">
                              {education.level}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Institution & Location */}
                    <div className="mb-4 space-y-2">
                      <div className="flex items-center gap-2 text-gray-700 dark:text-gray-300">
                        <FaUniversity className="text-primaryColor dark:text-primaryColorDark" />
                        <button
                          type="button"
                          onClick={() => console.log(education.institution)} // optional action
                          className="font-semibold hover:text-primaryColor dark:hover:text-primaryColorDark hover:underline transition-colors duration-300"
                        >
                          {education.institution}
                        </button>
                      </div>
                      <div className="flex items-center gap-2 text-gray-600 dark:text-gray-400 text-sm">
                        <FaMapMarkerAlt className="text-primaryColor dark:text-primaryColorDark" />
                        <span>{education.location}</span>
                      </div>
                    </div>

                    {/* Period & Duration */}
                    <div className="flex items-center gap-4 mb-4 flex-wrap">
                      <div className="flex items-center gap-2 text-primaryColor dark:text-primaryColorDark font-semibold">
                        <FaCalendarAlt />
                        <span>{education.period}</span>
                      </div>
                      <span className="text-gray-500 dark:text-gray-400 text-sm">
                        {/* ({education.duration}) */}
                      </span>
                    </div>

                    {/* Description */}
                    <p className="text-gray-600 dark:text-gray-300 leading-relaxed mb-4 transition-colors duration-300">
                      {education.description}
                    </p>

                    {/* Field */}
                    <div className="mb-4">
                      <span className="text-sm font-semibold text-gray-500 dark:text-gray-400">Field of Study: </span>
                      <span className="text-gray-700 dark:text-gray-300 font-medium">{education.field}</span>
                    </div>

                    {/* Achievements */}
                    <div className="mt-4 pt-4 border-t border-gray-200 dark:border-gray-600">
                      <div className="flex items-center gap-2 mb-3">
                        <FaAward className="text-primaryColor dark:text-primaryColorDark" />
                        <span className="text-sm font-semibold text-gray-700 dark:text-gray-300">Key Focus Areas:</span>
                      </div>
                      <div className="flex flex-wrap gap-2">
                        {education.achievements.map((achievement, idx) => (
                          <span
                            key={idx}
                            className="px-3 py-1 bg-primaryColor/10 dark:bg-primaryColorDark/20 text-primaryColor dark:text-primaryColorDark text-xs font-medium rounded-md"
                          >
                            {achievement}
                          </span>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Education;
